<template>
  <Layout>
    <SubHeader slot="sub-header" 
      :title="$t('common.detail')"
      :isBackground="false">
      <div slot="sub-header-tab" class="content-report-container" @click="reportContentModalIsShown = true">
        <img src="/static/images/ic-more-active.svg" alt="content-report-icon">
      </div>
    </SubHeader>
    <div slot="body" class="video-view">
      <LoadingBounce v-if="busy" />
      <template v-else>
        <Lvideo
          class="video"
          :videoId="videoId"
          :isVideoAutoState="isVideoAutoState"
          :isCourseCard="isCourseCard"
          :courseId="courseId"
          :videoUrl="videoUrl" 
          :nextVideoId="nextVideoId"
          @openPrimeModal="openPrimeModal"
          :savedPreviewVideoLecture="savedPreviewVideoLecture"
        />

        <div class="video-title">
          {{ videoTitle }}
        </div>

        <div class="video-publisher-name">
          {{ publisherName }}
        </div>

        <div class="video-subject">
          {{ videoGrade }}
          {{ videoSubjectName }}
        </div>

        <div class="video-view-count">
          {{ $t('common.view_count') }} {{ videoViewCount }}
        </div>

        <div class="video-like-count">
          {{ $t('common.like_up') }} {{ getToCommas(videoLikeCount) }}
        </div>

        <div class="video-description" v-html="videoDescription"></div>

        <div class="video-created-date">
          {{ $t('common.created_date') }} {{ videoCreatedDate }}
        </div>

        <div class="video-actions">
          <a @click="toggleLike()" :class="[ isLikeVideoLecture ? 'active' : '']">
            <img class="icon" :src="`/static/images/ic_post_light${isLikeVideoLecture ? '_active' : '_normal'}.svg`" />
            {{ $t('common.like_up') }}
          </a>
          <a @click="toggleBookmark()" :class="[ isBookmarkVideoLecture ? 'active' : '']">
          <img class="icon" :src="`/static/images/ic_bookmark${isBookmarkVideoLecture ? '_active' : ''}.svg`" />
            {{ $t('common.bookmark') }}
          </a>
        </div>

        <div class="video-course" v-if="isVideoCourse">
          <CourseCard :course="videoCourse" @click="viewCourse(videoCourse.id)"
            :isVideoCourse="true" />
        </div>

        <div class="video-relation">
          <div class="row align-items-center header">
            <div class="col-8 title">{{ isCourseCard ? $t('course.video_lecture') : $t('video_lecture.relation_video_lecture') }}</div>
            <div class="col-4 action">
              <ToggleSwitch @change="change" />
            </div>
          </div>

          <div class="row px-8">
            <div class="col-lg-6 col-md-6 col-sm-12 px-6 mb-2"
              v-for="(item, index) in videoLectures" :key="index">
              <LeftImageCard :videoLecture="item"
                :isCurrentCard="isCurrentCard(item.id)"
                :isCourseCard="isCourseCard"
                :courseId="courseId" />
            </div>
            <InfiniteLoading @infinite="infiniteHandler" class="w-100">
              <div slot="spinner">
                <LoadingBounce></LoadingBounce>
              </div>
              <span slot="no-results"></span>
              <span slot="no-more"></span>
            </InfiniteLoading>
          </div>
        </div>
      </template>

      <PrimeSnackBar v-if="isSnackBar"
        @okSnackBar="okSnackBar()"
        @closeSnackBar="closeSnackBar()" />

      <CustomModal
        :hide-header="true"
        class="basic-modal no-header-modal"
        :closeTitle="$t('prime.lecture_notice.cancel')"
        :okTitle="$t('prime.lecture_notice.confirm')"
        @ok="okPrimeModal()"
        @cancel="closePrimeModal()"
        v-if="isPrmieModal">
        <div v-html="$t('prime.lecture_notice.description')" />
      </CustomModal>

      <LicenceModal v-if="isLicenceModal"
        @ok="isLicenceModal = false" />

      <ReportContentModal
        class="content-report-modal"
        :videoLecture="videoLecture"
        @ok="onContentReportSent()"
        @cancel="reportContentModalIsShown = false"
        v-if="reportContentModalIsShown && videoLecture" />

      <CustomModal id="content-report-success-modal"
        class="basic-modal no-header-modal hide-cancel-btn content-report-modal"
        :hide-header="true"
        :isCloseButton="false"
        :ok-title="$t('common.confirmation')"
        @ok="contentReportSuccessModalIsShown = false"
        v-if="contentReportSuccessModalIsShown">
        <div v-html="$t('common.error_report')"></div>
      </CustomModal>

    </div>
  </Layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import moment from 'moment/src/moment';
  import { findIndex, isEmpty, has, find, filter, some, now, get } from 'lodash';
  import { CLASSTING_PAY_WEB } from '@/config';
  import InfiniteLoading from 'vue-infinite-loading';
  import numbers from '@/mixins/numbers';
  import labels from '@/mixins/labels';

  export default {
    name: 'video-lecture-view',

    data() {
      return {
        busy: false,
        videoLecture: {},
        videoLectures: {},
        videoCourse: {},
        isLikeVideoLecture: false,
        isBookmarkVideoLecture: false,
        isCourseSubscribed: false,
        isPrmieModal: false,
        isSnackBar: false,
        videoLikeCount: 0,
        page: 1,
        limit: 20,
        contentReportSuccessModalIsShown: false,
        reportContentModalIsShown: false,
        isVideoAutoState: JSON.parse(this.$localStorage.get('isVideoAutoState')),
        isLicenceModal: false,
        intervalId: null,
        now: now(),
        savedPreviewVideoLecture: JSON.parse(
          this.$localStorage.get(this.$store.getters.currentUserId),
        ),
      };
    },

    components: {
      InfiniteLoading,
    },

    mixins: [
      numbers,
      labels,
    ],

    computed: {
      ...mapGetters({
        routeParams: 'getRouteParams',
        routeQuery: 'getRouteQuery',
        subjectMap: 'getSubjectMap',
        gradeMap: 'getGradeMap',
        currentUserId: 'currentUserId',
        isSubscriptionUser: 'isSubscriptionUser',
        isPrime: 'isPrime',
        isUserLicence: 'isUserLicence',
        isPremiumSchool: 'isPremiumSchool',
        isPrimeSupportCountry: 'isPrimeSupportCountry',
        monitoringHistories: 'getMonitoringHistories',
      }),

      videoId() {
        return this.videoLecture && this.videoLecture.id;
      },

      video() {
        return this.videoLecture && this.videoLecture.video;
      },

      videoFiles() {
        return this.video && this.video.files;
      },

      filterVideoFile() {
        return find(this.videoFiles, { quality: 'hls' });
      },

      videoUrl() {
        return this.video && this.video.embed;
      },

      videoTitle() {
        return this.videoLecture && this.videoLecture.title;
      },

      videoPublisher() {
        return this.videoLecture && this.videoLecture.owner;
      },

      publisherName() {
        return this.videoPublisher && this.videoPublisher.name;
      },

      publisherId() {
        return this.videoPublisher && this.videoPublisher.id;
      },

      filterSubject() {
        return find(this.subjectMap, { id: this.videoLecture.subject_id }) || {};
      },

      videoSubjectName() {
        return this.filterSubject.name;
      },

      videoGrade() {
        return this.getTranslatedName(this.gradeMap[this.videoLecture.grade_id]);
      },

      videoViewCount() {
        return this.getToCommas(this.videoLecture && this.videoLecture.view_count);
      },

      videoDescription() {
        return (this.videoLecture && this.videoLecture.description).replace(/\n/g, '<br>');
      },

      videoCreatedDate() {
        return moment(this.videoLecture && this.videoLecture.created_at).format('YYYY.MM.DD');
      },

      isNotNextPlay() {
        return some(this.videoLectures, { id: this.videoId });
      },

      nextVideoIndex() {
        if (this.isCourseCard) {
          return findIndex(this.videoLectures, { id: this.videoId }) + 1;
        }

        if (this.isNotNextPlay) {
          return 1;
        }

        return 0;
      },

      nextVideo() {
        if (this.isCourseCard && this.nextVideoIndex === 0) {
          return null;
        }

        return this.videoLectures[this.nextVideoIndex];
      },

      nextVideoId() {
        if (!this.nextVideo) {
          return 0;
        }

        return this.nextVideo.id;
      },

      isCourseCard() {
        if (has(this.routeQuery, 'course_id')) {
          return true;
        }

        return false;
      },

      isVideoCourse() {
        return !isEmpty(this.videoCourse);
      },

      courseId() {
        return Number(this.routeQuery.course_id) || 0;
      },

      videoLectureId() {
        return this.routeParams.videoId;
      },

    },

    methods: {
      ...mapActions([
        'fetchSubjects',
        'fetchVideoLecture',
        'fetchSimilarVideoLectures',
        'fetchVideoLectures',
        'fetchVideoLectureIsLiked',
        'fetchVideoCourse',
        'fetchVideoCourseIsSubscribed',
        'createVideoLectureLike',
        'removeVideoLectureLike',
        'fetchFilterVideoLectures',
        'fetchVideoLectureIsBookmarked',
        'createVideoLectureViews',
        'createVideoLectureBookmark',
        'removeVideoLectureBookmark',
      ]),

      showPrime() {
        if (this.$mobile.isClasstingClient()) {
          return this.$mobile.openNewWebView(CLASSTING_PAY_WEB);
        }

        return window.open(CLASSTING_PAY_WEB);
      },

      okSnackBar() {
        this.$ga.event({
          eventCategory: 'prime',
          eventLabel: 'snackbar_video_lecture',
          eventAction: 'click',
        });

        this.isSnackBar = false;
        this.showPrime();
      },

      openSnackBar() {
        this.isSnackBar = true;
      },

      closeSnackBar() {
        this.isSnackBar = false;
      },

      setVideoLectureEventCount(count) {
        return this.$localStorage.set('videoLectureEventCount', count);
      },

      getVideoLectureEventCount() {
        return Number(this.$localStorage.get('videoLectureEventCount') || 0);
      },

      okPrimeModal() {
        this.$ga.event({
          eventCategory: 'prime',
          eventLabel: 'modal_preview_video',
          eventAction: 'click',
        });

        this.isPrmieModal = false;
        this.showPrime();
      },

      openPrimeModal() {
        if (this.isPrimeSupportCountry) {
          this.isPrmieModal = true;
          return true;
        }

        this.isLicenceModal = true;
        return true;
      },

      closePrimeModal() {
        this.isPrmieModal = false;
      },

      isCurrentCard(id) {
        return id === this.videoId;
      },

      onContentReportSent() {
        this.reportContentModalIsShown = false;
        this.contentReportSuccessModalIsShown = true;
      },

      viewCourse(courseId) {
        this.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: 'video_lecture.course',
          eventAction: 'click',
        });

        return this.$router.push({
          name: 'video-course-view',
          params: {
            courseId,
          },
        });
      },

      infiniteHandler($state) {
        this.paginationVideoLectures()
          .then((data) => {
            if (data.length > 0) {
              this.videoLectures = this.videoLectures.concat(data);
              return $state.loaded();
            }
            return $state.complete();
          });
      },

      paginationVideoLectures() {
        this.page += 1;
        const filters = {
          page: this.page,
          per_page: this.limit,
        };

        return Promise.resolve()
          .then(() => {
            if (this.isCourseCard) {
              filters.video_course_id = this.courseId;
              return this.fetchVideoLectures(filters);
            }

            return this.fetchSimilarVideoLectures({ filters, lectureId: this.videoLectureId });
          });
      },

      change(value) {
        if (value) {
          this.$ga.event({
            eventCategory: 'recommended_lectures',
            eventLabel: 'video_lecture',
            eventAction: 'auto_play_on',
          });
        }

        if (!value) {
          this.$ga.event({
            eventCategory: 'recommended_lectures',
            eventLabel: 'video_lecture',
            eventAction: 'auto_play_off',
          });
        }

        this.$localStorage.set('isVideoAutoState', value);
        this.isVideoAutoState = JSON.parse(this.$localStorage.get('isVideoAutoState'));
      },

      toggleLike() {
        if (!this.isLikeVideoLecture) {
          this.$ga.event({
            eventCategory: 'recommended_lectures',
            eventLabel: 'video_lecture',
            eventAction: 'light_up',
          });

          return this.createVideoLectureLike(this.videoLectureId)
            .then((isLikeVideoLecture) => {
              this.isLikeVideoLecture = isLikeVideoLecture;
              this.videoLikeCount += 1;
            });
        }

        this.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: 'video_lecture',
          eventAction: 'unlit',
        });

        return this.removeVideoLectureLike(this.videoLectureId)
          .then((isLikeVideoLecture) => {
            this.isLikeVideoLecture = isLikeVideoLecture;
            this.videoLikeCount -= 1;
          });
      },

      toggleBookmark() {
        if (!this.isBookmarkVideoLecture) {
          this.$ga.event({
            eventCategory: 'recommended_lectures',
            eventLabel: 'video_lecture',
            eventAction: 'bookmark',
          });

          return this.createVideoLectureBookmark(this.videoLectureId)
            .then((isBookmarkVideoLecture) => {
              this.isBookmarkVideoLecture = isBookmarkVideoLecture;
            });
        }

        this.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: 'video_lecture',
          eventAction: 'unbookmark',
        });

        return this.removeVideoLectureBookmark(this.videoLectureId)
          .then((isBookmarkVideoLecture) => {
            this.isBookmarkVideoLecture = isBookmarkVideoLecture;
          });
      },

      initVideoLecture() {
        this.$route.meta.title = this.$t('common.detail');
        this.busy = true;
        Promise.resolve()
          .then(() => {
            if (isEmpty(this.subjectMap)) {
              return this.fetchSubjects();
            }
            return true;
          })
          .then(() => {
            this.fetchVideoLecture(this.videoLectureId)
              .then((videoLecture) => {
                this.videoLecture = videoLecture;
                this.videoLikeCount = videoLecture.like_count;
                if (videoLecture.video_course_id) {
                  return this.fetchVideoCourse(videoLecture.video_course_id)
                    .then((videoCourse) => {
                      this.videoCourse = videoCourse;
                      return this.fetchVideoCourseIsSubscribed({
                        courseId: videoLecture.video_course_id,
                        userId: this.currentUserId,
                      })
                      .then((isCourseSubscribed) => {
                        this.isCourseSubscribed = isCourseSubscribed;
                      });
                    });
                }
                return true;
              });
          })
          .then(() => {
            const params = {
              owner_id: this.publisherId,
              is_prime: this.isPrime,
              is_user_licence: this.isUserLicence,
              is_school_licence: this.isPremiumSchool,
            };
            return this.createVideoLectureViews({ lectureId: this.videoLectureId, params });
          })
          .then(() => {
            this.fetchVideoLectureIsLiked({
              lectureId: this.videoLectureId,
              userId: this.currentUserId,
            })
            .then((isLikeVideoLecture) => {
              this.isLikeVideoLecture = isLikeVideoLecture;
            });
            return true;
          })
          .then(() => {
            this.fetchVideoLectureIsBookmarked({
              lectureId: this.routeParams.videoId,
              userId: this.currentUserId,
            })
            .then((isBookmarkVideoLecture) => {
              this.isBookmarkVideoLecture = isBookmarkVideoLecture;
            });
          })
          .then(() => {
            this.page = 1;
            const filters = {
              page: this.page,
              per_page: this.limit,
            };

            if (this.isCourseCard) {
              filters.video_course_id = this.courseId;
              return this.fetchVideoLectures(filters);
            }

            return this.fetchSimilarVideoLectures({ filters, lectureId: this.videoLectureId });
          })
          .then((videoLectures) => {
            this.videoLectures = videoLectures;
            return true;
          })
          .then(() => {
            if (this.isNotNextPlay && !this.isCourseCard) {
              this.videoLectures = filter(this.videoLectures, item => item.id !== this.videoId);
            }
            return true;
          })
          .then(() => {
            if (this.nextVideoId === 0 && this.isCourseCard) {
              return this.paginationVideoLectures()
                .then((data) => {
                  this.videoLectures = this.videoLectures.concat(data);
                });
            }

            return true;
          })
          .then(() => {
            this.$ga.event({
              eventCategory: 'recommended_lectures',
              eventLabel: 'video_lecture_light',
              eventAction: 'view',
              eventValue: this.videoLikeCount,
            });

            this.$ga.event({
              eventCategory: 'recommended_lectures',
              eventLabel: 'video_lecture_view',
              eventAction: 'view',
              eventValue: this.videoLecture && this.videoLecture.view_count,
            });

            if (!this.isSubscriptionUser && !this.getVideoLectureEventCount()) {
              return this.setVideoLectureEventCount(1);
            }

            if (!this.isSubscriptionUser && this.getVideoLectureEventCount()) {
              const eventCount = this.getVideoLectureEventCount() + 1;
              return this.setVideoLectureEventCount(eventCount);
            }

            return true;
          })
          .then(() => {
            const videoLectureViewCount = 12;

            if (
              !this.isSubscriptionUser
              && this.isPrimeSupportCountry
              && this.getVideoLectureEventCount() >= videoLectureViewCount
            ) {
              this.$ga.event({
                eventCategory: 'prime',
                eventLabel: 'snackbar_video_lecture',
                eventAction: 'view',
              });
              this.$localStorage.set('videoLectureEventCount', 0);
              this.openSnackBar();
              return true;
            }
            return true;
          })
          .then(() => {
            if (
              !this.isSubscriptionUser
              && get(this.savedPreviewVideoLecture, 'date') !== moment().format('YYYY-MM-DD')
            ) {
              const previewVideoLecture = {
                date: moment().format('YYYY-MM-DD'),
                viedo_lecture_id: this.videoLectureId,
                user_id: this.currentUserId,
              };

              return this.$localStorage.set(this.currentUserId, JSON.stringify(previewVideoLecture));
            }

            return true;
          })
          .then(() => {
            this.busy = false;
          });
      },

    },

    beforeMount() {
      this.initVideoLecture();
    },

    beforeDestroy() {
      clearInterval(this.intervalId);
    },

    watch: {
      $route() {
        clearInterval(this.intervalId);
        this.initVideoLecture();
      },
      nextVideo() {
        if (this.nextVideoId === 0 && this.isCourseCard) {
          this.paginationVideoLectures()
            .then((data) => {
              this.videoLectures = this.videoLectures.concat(data);
            });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  $video-text-color: rgba(0, 0, 0, 0.54);

  .content-report-container {
    width: 28px;
    height: 28px;
    float: right;
    text-align: center;
    vertical-align: center;
    cursor: pointer;
    border-radius: 4px;
    border: solid 1px #d9d9d9;
  }

  .video-view {
    max-width: 946px;
    margin: 14px auto;
    padding: 0px 14px 0px 14px;

    .video-title {
      font-size: 16px;
      padding: 44px 0px 16px 0px;
      font-weight: bold;
      word-break: break-all;
    }

    .video-publisher-name {
      font-size: 14px;
      color: $video-text-color;
    }

    .video-subject {
      font-size: 14px;
      color: $video-text-color;
      margin-top: 4px;
      margin-bottom: 10px;
    }

    .video-view-count {
      display: inline-block;
      color: $video-text-color;
    }

    .video-like-count {
      display: inline-block;
      color: $video-text-color;
    }

    .video-description {
      padding: 40px 0px 24px 0px;
      color: $video-text-color;
      word-break: break-all;
    }

    .video-created-date {
      padding-bottom: 14px;
      text-align: right;
      color: $video-text-color;
    }

    .video-actions {
      text-align: right;
      padding-bottom: 24px;

      .active {
        color: #00c896;

        &:hover {
          color: #00c896;
        }
      }

      .icon {
        vertical-align: text-bottom;
        margin: 0px 4px 0px 4px;
        height: 20px;
        width: 20px;
      }

      a {
        display: inline-block;
        margin: 16px 0px 16px 32px;
        cursor: pointer;
        color: $video-text-color;

        &:hover {
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }

    .video-course {
      padding-bottom: 44px;
    }

    .video-relation {

      .header {
        padding: 20px;

        .title {
          font-size: 18px;
          padding: 0;

          strong {
            color: #00c896;
          }
        }
      
        .action {
          text-align: right;
        }
      }
    }

    .next-video {

      .header {
        padding: 20px;

        .title {
          font-size: 18px;
          padding: 0;
        }
      
        .action {
          text-align: right;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// VideoLectureView.vue?0e1780fc